export default __webpack_public_path__ + "static/single-binder-bg-e4acab9d2082f80e2aafad7d1379126e.svg";